export default __webpack_public_path__ + "static/amandeep-258d9915329da73cff359d9a406b970b.png";